import React, { useEffect, useState } from "react";
import tag from "./tag/tag";
import value from "./value/value";
import warranty from "./warranty/warranty";
import itemAdd from "./item-add";
import FormHeader from "../../../../styled-components/form-header/form-header";
import RightSidebar from "../../../../styled-components/right-sidebar/right-sidebar";
import useActiveTabs from "../../../../../hooks/active-tabs";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { MODULE_API } from "../../../../../apis";
import NewLoader from "../../../../styled-components/loader/NewLoader";
function ItemUpdate(props) {
  // const { isUpdate, editItem, data, property } = props;
  const [property, setProperty] = useState(null);
  const [room, setRoom] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [activeTabData, setActiveTabData] = useState({
    name: "generalInformation",
    title: "General Information",
    unique: "firstName",
    isMulti: false,
    component: itemAdd,
  });
  const { id } = useParams();
  const { propertyId } = useParams();
  const { roomId } = useParams();
  const fetchProperty = async () => {
    setLoading(true);
    let itemDetails = await MODULE_API.fetchRooms({
      id: propertyId,
      body: {},
    });
    if (itemDetails && itemDetails.data) {
      setProperty(itemDetails.data);
    }
    setLoading(false);
  };
  const fetchRoom = async () => {
    setLoading(true);
    let itemDetails = await MODULE_API.fetchRooms({
      id: roomId,
      body: {},
    });
    if (itemDetails && itemDetails.data) {
      setRoom(itemDetails.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (propertyId) {
      fetchProperty();
    }
  }, [propertyId]);
  useEffect(() => {
    if (roomId) {
      fetchRoom();
    }
  }, [roomId]);

  const [itemsAddData, setItemsAddData] = useState({
    generalInformation: {
      name: "generalInformation",
      title: "General Information",
      unique: "firstName",
      isMulti: false,
      dataProp: location,
      component: itemAdd,
      data: [
        {
          Name: "",
          UniversalProductCode: "",
          SerialNumber: "",
          Owner: "",
          Brand: "",
          Model: "",
          SpecialFeatures: "",
          Property: "",
          Room: "",
          UploadImage: "",
          UploadVideo: "",
        },
      ],
    },
    valueDetails: {
      name: "valueDetails",
      title: "Value",
      unique: "firstName",
      isMulti: false,
      component: value,
      data: [
        {
          Quantity: "",
          PricePaid: "",
          CurrentValue: "",
          Condition: "",
          Appreciation: "",
          AppraisalSource: "",
          AppraisalDate: "",
          Appraisal: "",
        },
      ],
    },
    warranty: {
      name: "warranty",
      title: "Warranty",
      unique: "firstName",
      component: warranty,
      isMulti: false,
      data: [
        {
          PurchaseDate: "",
          PurchaseLocation: "",
          WarrantyProviders: "",
          WarrantyPeriod: "",
          CustomerSupportPhone: "",
          WebsiteURL: "",
          ReturnDate: "",
          Receipt: "",
        },
      ],
    },
    tag: {
      name: "tag",
      title: "Tag",
      unique: "matric",
      isMulti: false,
      dataProp: location,
      component: tag,
      data: [
        {
          TagName: "",
        },
      ],
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      if (!id || !property || !room) return; // wait until all are available
      if (id) {
        setLoading(true);
        let item = await MODULE_API.fetchRooms({
          id: id,
          body: {},
        });
        setLoading(false);
        setItemsAddData({
          generalInformation: {
            name: "generalInformation",
            title: "General Information",
            unique: "firstName",
            isMulti: false,
            dataProp: location,
            component: itemAdd,
            data: [
              {
                Name: item && item.data.name,
                UniversalProductCode: item && item.data.upc,
                SerialNumber: item && item.data.serialNumber,
                Owner: item && item.data.ownerName,
                Brand: item && item.data.brandName,
                Model: item && item.data.model,
                SpecialFeatures: item && item.data.specialFeatures,
                Property: property && { value: property.name, id: property.id },
                Room: room && { value: room.name, id: room.id },
                UploadImage:
                  item && item.data.images && item && item.data.images,
                UploadVideo:
                  item && item.data.videos && item && item.data.videos,
              },
            ],
          },
          valueDetails: {
            name: "valueDetails",
            title: "Value",
            unique: "firstName",
            isMulti: false,
            component: value,
            data: [
              {
                Quantity: item && item.data.quantity,
                PricePaid: item && item.data.pricePaid,
                CurrentValue: item && item.data.currentValue,
                Condition: item && item.data.condition,
                Appreciation: item && item.data.appreciationDepreciation,
                AppraisalSource: item && item.data.appraisalSource,
                AppraisalDate: item && item.data.appraisalDate,
                Appraisal: item && item.data.appraisal,
              },
            ],
          },
          warranty: {
            name: "warranty",
            title: "Warranty",
            unique: "firstName",
            component: warranty,
            isMulti: false,
            data: [
              {
                PurchaseDate: item && item.data.purchaseDate,
                PurchaseLocation: item && item.data.purchaseLocation,
                WarrantyProviders: item && item.data.warrantyProviders,
                WarrantyPeriod: item && item.data.warrantyPeriod,
                CustomerSupportPhone: item && item.data.customerSupportPhone,
                WebsiteURL: item && item.data.websiteURL,
                ReturnDate: item && item.data.returnEndDate,
                Receipt: item && item.data.reciept,
              },
            ],
          },
          tag: {
            name: "tag",
            title: "Tag",
            unique: "matric",
            isMulti: false,
            dataProp: location,
            component: tag,
            data: [
              {
                TagName: item && item.data.tags,
              },
            ],
          },
        });
      }
    };
    fetchData();
  }, [props, property, room, id]);
  const [rightToggleClass, setRightToggleClass] = useState(false);
  const [allFormsData, setAllFormsData] = useState(itemsAddData);
  useEffect(() => {
    setAllFormsData(itemsAddData);
  }, [itemsAddData]);
  console.log(allFormsData, "allFormsData");
  const [activeTabsArray, setActiveTabsArray] = useState([
    "generalInformation",
  ]);

  const ActiveComponent = activeTabData.component;
  const handleRightToggleClass = () => {
    setRightToggleClass(!rightToggleClass);
  };

  const tabsArray = Object.values(itemsAddData);

  //  pass all tabs array and selected tab name to useActiveTabs hook
  //  useActiveTabs Hook will return all previous tabs with selected tab
  const handleActiveTabsArray = (name) => {
    const activeTabs = useActiveTabs(tabsArray, name);

    setActiveTabsArray([...activeTabs]);
  };

  const nextForm = (nextFormData) => {
    setActiveTabData(nextFormData);

    const activeTabs = useActiveTabs(tabsArray, nextFormData.name);

    setActiveTabsArray([...activeTabs]);
  };
  const preForm = (previousFormData) => {
    setActiveTabData(previousFormData);

    const activeTabs = useActiveTabs(tabsArray, previousFormData.name);

    setActiveTabsArray([...activeTabs]);
  };

  // pass all form data of one component and update in main object (allFormsData)
  const handleItemsAddObject = (pageData) => {
    setAllFormsData((formData) => {
      console.log("formData", formData);
      console.log("activeTabData", activeTabData);
      return {
        ...formData,
        [activeTabData.name]: {
          ...formData[activeTabData.name],
          data: activeTabData.isMulti ? pageData : [pageData],
        },
      };
    });
  };

  return (
    <>
      <div
        className={
          rightToggleClass
            ? "form-page-container-wrap right-side--opend"
            : "form-page-container-wrap right-side--collapsed"
        }
        style={{ position: "relative" }}
      >
        <div>{location.id}</div>

        <div style={{ paddingRight: rightToggleClass ? "400px" : "0px" }}>
          <FormHeader
            headerData={itemsAddData}
            activeTabData={activeTabData}
            setActiveTabData={setActiveTabData}
            activeTabsArray={activeTabsArray}
            handleActiveTabsArray={handleActiveTabsArray}
          />
        </div>
        <div style={{ paddingRight: rightToggleClass ? "400px" : "0px" }}>
          <ActiveComponent
            handleItemsAddObject={handleItemsAddObject}
            data={allFormsData}
            nextForm={nextForm}
            preForm={preForm}
            activeTabData={activeTabData}
            // prevData={itemsAddData}
            itemId={id}
            isUpdate={true}
          />
        </div>
        <NewLoader isLoading={loading} />
        {/* <div className="form-page--right-side custom">
          <span
            className="right-side-collapse-icon"
            onClick={handleRightToggleClass}
          >
            <i className="fe-menu"></i>
          </span>
          <div className="form-page--right-side-wrap">
            <RightSidebar data={allFormsData} />
          </div>
        </div> */}
      </div>
    </>
  );
}

export default ItemUpdate;
